"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _order = require("@/api/iot/order");
var _status = require("@/api/iot/status");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _editDialog = _interopRequireDefault(require("./dialog/editDialog"));
var _authInfoDialog = _interopRequireDefault(require("./dialog/authInfoDialog"));
var _default = {
  components: {
    customPage: _customPage.default,
    editDialog: _editDialog.default,
    authInfoDialog: _authInfoDialog.default
  },
  data: function data() {
    return {
      loading: true,
      searchForm: {
        merchant_id: '',
        trade_no: '',
        user_name: '',
        mobile: '',
        pay_status: '',
        bindDate: ''
      },
      total: 0,
      tableData: [],
      orderPayStatusList: [],
      merchantList: [],
      editItem: null
    };
  },
  mounted: function mounted() {
    this.init();
    this.getOrderPayStatusList();
    this.getList();
  },
  methods: {
    init: function init() {
      if (this.sMerchantId == 0) {
        this.getMerchantList();
      }
      this.loadQuery();
    },
    loadQuery: function loadQuery() {
      var query = this.$route.query;
      console.log('query', query);
      for (var key in this.searchForm) {
        if (query[key]) {
          this.searchForm[key] = query[key];
        }
      }
    },
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res, _this$merchantList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  (_this$merchantList = this.merchantList).push.apply(_this$merchantList, (0, _toConsumableArray2.default)(res.data));
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getOrderPayStatusList: function getOrderPayStatusList() {
      var _this = this;
      (0, _status.getOrderPayStatusList)().then(function (res) {
        console.log('getOrderPayStatusList', res);
        if (res) {
          _this.orderPayStatusList = res || [];
        }
      });
    },
    getList: function getList(flag) {
      var _this2 = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      (0, _order.orderList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this2.loading = false;
        _this2.tableData = res.data || [];
        _this2.total = res.total;
      });
    },
    // 编辑
    openEditDialog: function openEditDialog(val) {
      this.editItem = val || null;
      this.$refs.editDialog.dialogVisible = true;
    },
    // 用户认证信息
    openAuthInfoDialog: function openAuthInfoDialog(val) {
      this.editItem = val || null;
      this.$refs.authInfoDialog.dialogVisible = true;
    },
    // 检测支付状态
    chkPayStatusType: function chkPayStatusType(item) {
      var type = 'info';
      if (item.pay_status == 1) {
        type = 'success';
      } else if (item.pay_status == 2) {
        type = 'warning';
      }
      return type;
    },
    // 退租
    surrenderOrder: function surrenderOrder(item) {
      this.$confirm('您确定要退租吗?', '退租', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 删除
    removeItem: function removeItem(item) {
      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        // delUser(item.id).then((res) => {
        //     this.getList(true)
        // })
      }).catch(function () {});
    },
    // 批量操作
    handleCommand: function handleCommand(command) {},
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      this.getList();
    }
  }
};
exports.default = _default;